import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Markdown from '@/components/Markdown';
import {
  Container,
  HeroImage,
  News,
  NewsTitle,
  NewsBody,
  MenuContents,
  MenuCategory,
  MenuCategoryTitle,
  MenuCategoryList,
  MenuCategoryListItem,
  MenuCategoryListItemTitle,
  MenuCategoryListItemLink,
  SalonConsultationText,
} from './HomePage.style';
import Placeholder from '../../../components/Placeholder';
import Image from '../../../components/ContentfulImage';
import salonConsultationTop from '../../../redux/actions/salonConsultationTop';
// import { getScalpCameraGuide } from '../../../redux/actions/scalpCameraOption';
import { errorLogger, lsGetItem } from '../../../utils';
import { STYLIST_SALONID, CUSTOMER } from '../localStorageKeys';

class HomePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { locale } = this.props;

    this.loadSalonConsultationTop(locale);
  }

  loadSalonConsultationTop = () => {
    const { locale, updateError, salonConsultationTop } = this.props;

    salonConsultationTop(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  handleDiagnosis = () => {
    const { history } = this.props;
    history.push('sublimic/home');
  };

  handleButtonTap = e => {
    const { history } = this.props;
    const url = e.currentTarget.getAttribute('href');
    const external = e.currentTarget.dataset.external;
    if (external === 'true') {
      window.open(url, '_blank');
    } else {
      history.push(url);
    }
    e.preventDefault();
    return false;
  };

  render() {
    const { copy } = this.props;
    const { title, titleImage, newsLabel, newsDescription, contents } =
      (copy && copy) || {};
    return (
      <React.Fragment>
        <Container>
          <HeroImage>
            {(!!titleImage && <Image src={titleImage} options={{ w: '100%', h: '100%', objectFit: 'cover' }} />) || (
              <Placeholder w="100%" h="100%" />
            )}
            <SalonConsultationText>{title || <Placeholder w="100%" h="30px" />}</SalonConsultationText>
            <News>
              <NewsTitle>{newsLabel || <Placeholder w="20%" h="30px" />}</NewsTitle>
              <Markdown src={newsDescription} Component={NewsBody} />
            </News>
          </HeroImage>
          <MenuContents>
            {(contents &&
              contents.map(category => (
                <MenuCategory key={category.entryId}>
                  <MenuCategoryTitle>{category.title || <Placeholder w="20%" h="30px" />}</MenuCategoryTitle>
                  <MenuCategoryList>
                    {category.linkSection &&
                      category.linkSection.map(item => (
                        <MenuCategoryListItem key={item.entryId}>
                          <MenuCategoryListItemTitle>
                            {item.copy || <Placeholder w="100%" h="30px" />}
                          </MenuCategoryListItemTitle>
                          <MenuCategoryListItemLink
                            href={item.url || null}
                            onClick={this.handleButtonTap}
                            data-external={item.external}
                          >
                            {item.label || <Placeholder w="100%" h="30px" />}
                          </MenuCategoryListItemLink>
                        </MenuCategoryListItem>
                      ))}
                  </MenuCategoryList>
                </MenuCategory>
              ))) || (
              <React.Fragment>
                <MenuCategory>
                  <MenuCategoryTitle>
                    <Placeholder w="30%" h="30px" />
                  </MenuCategoryTitle>
                  <MenuCategoryList>
                    <MenuCategoryListItem>
                      <MenuCategoryListItemTitle>
                        <Placeholder w="100%" h="30px" />
                      </MenuCategoryListItemTitle>
                      <MenuCategoryListItemLink>
                        <Placeholder w="100%" h="60px" />
                      </MenuCategoryListItemLink>
                    </MenuCategoryListItem>
                    <MenuCategoryListItem>
                      <MenuCategoryListItemTitle>
                        <Placeholder w="100%" h="30px" />
                      </MenuCategoryListItemTitle>
                      <MenuCategoryListItemLink>
                        <Placeholder w="100%" h="60px" />
                      </MenuCategoryListItemLink>
                    </MenuCategoryListItem>
                  </MenuCategoryList>
                </MenuCategory>
                <MenuCategory>
                  <MenuCategoryTitle>
                    <Placeholder w="30%" h="30px" />
                  </MenuCategoryTitle>
                  <MenuCategoryList>
                    <MenuCategoryListItem>
                      <MenuCategoryListItemTitle>
                        <Placeholder w="100%" h="30px" />
                      </MenuCategoryListItemTitle>
                      <MenuCategoryListItemLink>
                        <Placeholder w="100%" h="60px" />
                      </MenuCategoryListItemLink>
                    </MenuCategoryListItem>
                    <MenuCategoryListItem>
                      <MenuCategoryListItemTitle>
                        <Placeholder w="100%" h="30px" />
                      </MenuCategoryListItemTitle>
                      <MenuCategoryListItemLink>
                        <Placeholder w="100%" h="60px" />
                      </MenuCategoryListItemLink>
                    </MenuCategoryListItem>
                  </MenuCategoryList>
                </MenuCategory>
              </React.Fragment>
            )}
          </MenuContents>
        </Container>
      </React.Fragment>
    );
  }
}

HomePage.defaultProps = {
  copy: {},
};
HomePage.propTypes = {
  history: PropTypes.arrayOf(PropTypes.object).isRequired,
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  updateError: PropTypes.func.isRequired,
  salonConsultationTop: PropTypes.func.isRequired,
};
const mapState = state => ({
  copy: state.salonConsultationTop,
  locale: state.locale,
});
const mapDispatch = dispatch => ({
  updateError: error => dispatch({ type: 'UPDATE_ERROR', error }),
  salonConsultationTop: locale => dispatch(salonConsultationTop(locale)),
});
export default connect(mapState, mapDispatch)(HomePage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/HomePage/HomePage.js